import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS } from '../../lib/site';
import { PhoneButton } from './PhoneButton';

const linkCls = ({ isActive }) =>
  `text-sm font-medium tracking-wide ${isActive ? 'text-orange-400' : 'text-slate-300 hover:text-white'}`;

const NavItem = ({ item, prefix, onClick }) =>
  item.href ? (
    <a href={item.href} target="_blank" rel="noopener noreferrer" onClick={onClick}
      data-testid={`${prefix}-${item.testid}-link`} className="text-sm font-medium tracking-wide text-slate-300 hover:text-white">
      {item.label}
    </a>
  ) : (
    <NavLink to={item.to} end onClick={onClick} data-testid={`${prefix}-${item.testid}-link`} className={linkCls}>
      {item.label}
    </NavLink>
  );

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-[#060A17]/80 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3 flex items-center justify-between gap-6">
        <Link to="/" data-testid="header-logo-link" className="bg-white rounded-xl px-2.5 py-1.5 shadow-lg hover:opacity-90 shrink-0">
          <img src="/assets/zivae-logo.jpg" alt="Zivae Financial" className="h-11 w-auto no-zoom" />
        </Link>
        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((item) => <NavItem key={item.testid} item={item} prefix="nav" />)}
        </nav>
        <div className="hidden xl:flex items-center gap-2">
          <PhoneButton type="financial" testid="header-phone-financial" showLabel={false} />
          <PhoneButton type="medicare" testid="header-phone-medicare" showLabel={false} />
        </div>
        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu"
          className="lg:hidden p-2 text-slate-200 hover:text-orange-400">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-nav" className="lg:hidden border-t border-white/10 px-5 py-5 flex flex-col gap-4 bg-[#060A17]">
          {NAV_LINKS.map((item) => <NavItem key={item.testid} item={item} prefix="mobile-nav" onClick={() => setOpen(false)} />)}
          <div className="flex flex-col gap-2 pt-2">
            <PhoneButton type="financial" testid="mobile-phone-financial" />
            <PhoneButton type="medicare" testid="mobile-phone-medicare" />
          </div>
        </nav>
      )}
    </header>
  );
};
